import { Alert as ReactAlert, AlertProps } from '@a-ui/react';
import React from 'react';
import Box from '../../../components/Box';
import { DetailLayout } from '../../../components/DetailLayout';
import Link from '../../../components/Link';
import Typography from '../../../components/Typography';
import { translate, translateHTML } from '../../../i18n';
import { ITranslations } from '../../../i18n/config';
import { useAuthentication } from '../../../state/Authentication';

interface EmailVerifyMessageProps {
  type: AlertProps['theme'];
  pageTitle: ITranslations;
  pageDescription: ITranslations;
  title: ITranslations;
  summary: ITranslations;
  body: ITranslations;
}

const EmailVerifyMessage: React.FC<EmailVerifyMessageProps> = ({
  type,
  pageTitle,
  pageDescription,
  title,
  summary,
  body,
}) => {
  const {
    state: { isAuthenticated },
  } = useAuthentication();

  return (
    <DetailLayout
      title={pageTitle}
      description={pageDescription}
      backAction="/gegevens"
      backLabel="accessKeys.overview.title"
    >
      <Box>
        <Typography variant="h2" as="h6" classNames="u-margin-bottom-xs">
          {translate(title)}
        </Typography>

        <div className="u-margin-bottom-xs">
          <ReactAlert theme={type}>
            <Typography>{translateHTML(summary)}</Typography>
          </ReactAlert>
        </div>

        <Typography classNames="u-margin-bottom">{translate(body)}</Typography>

        {isAuthenticated ? (
          <Link to="/gegevens" classNames="a-button">
            {translate('accessKeys.verify.message.back')}
          </Link>
        ) : (
          <Link to="/auth/login" classNames="a-button">
            {translate('accessKeys.verify.message.login')}
          </Link>
        )}
      </Box>

      <div className="u-margin-top">
        <Typography variant="h2" as="h6" classNames="u-margin-bottom-xs">
          {translate('newsletters.teaser.title')}
        </Typography>

        <Typography>
          <Link to="/nieuwsbrieven">{translate('newsletters.teaser.link')}</Link>
        </Typography>
      </div>
    </DetailLayout>
  );
};

export default EmailVerifyMessage;
